import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    paper: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(4),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      boxShadow: "2px 2px 8px 5px rgba(0, 0, 0, .1)",
      borderRadius: "10px",
      padding: theme.spacing(3),
      backgroundColor: 'white'
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(1),
    },
    txtField: {
        // borderRadius: '20px',
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
      padding: theme.spacing(1.2),
      fontWeight: 600,
      color: 'black',
    //   borderRadius: '20px',
    },
  }));